export const ADMIN_EMAILS = ['sealtreumk@gmail.com', 'salimueky@gmail.com'];

export const isAdmin = (email: string | null | undefined): boolean => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email);
};
